import {DataFetcher} from '@aboutyou/data-fetcher';
import {JsonLD_Breadcrumb} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/meta/service.types';
import React, {FC} from 'react';
import {useArticleDetailPageMetaData} from './PageMetaData';

const generateItemsList = (breadcrumbs: JsonLD_Breadcrumb[]) => {
  return breadcrumbs.map((breadcrumb, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': breadcrumb.url,
        name: breadcrumb.name,
      },
    };
  });
};

const createBreadcrumbsJsonLd = (breadcrumbs: JsonLD_Breadcrumb[]) => {
  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: generateItemsList(breadcrumbs),
  });
};

export const PageMetaDataJsonLd: FC = () => {
  return (
    <DataFetcher
      request={useArticleDetailPageMetaData()}
      Error={null}
      View={({jsonLd}) => (
        <>
          {jsonLd?.breadcrumbs && (
            <script
              type="application/ld+json"
              data-testid="Breadcrumbs"
              dangerouslySetInnerHTML={{
                __html: createBreadcrumbsJsonLd(jsonLd.breadcrumbs),
              }}
            />
          )}
          {jsonLd?.product && (
            <script
              type="application/ld+json"
              data-testid="Productinfos"
              dangerouslySetInnerHTML={{
                __html: jsonLd.product,
              }}
            />
          )}
        </>
      )}
    />
  );
};
